<template>
  <div class="upper-subpanel--inside">
    <div class="col-6">
      <div class="with-child-centered">
        <h5>請輸入藥物名稱</h5> 
        <input ref="input" class="form-control drug-search-input" type="text" id="drug-name" name="drug_name" v-model="query" placeholder="輸入藥物名稱">
        <div class="btn control-button-red" @click="query = ''">重新輸入</div>
      </div>
    </div>

    <div class="col-6">
      <div class="drug-search-list drug-search-list--large" v-if="query_result" id="drug-search-list">
        <div v-for="drug in query_result" @click="setDrug(drug.id)" class="btn drug-button">
          <h6>
            <span>[ 
              <span v-if="drug.CGMH_number !== null">{{drug.CGMH_number }} - </span>
              {{ drug.code }} ]
            </span> 
            {{ drug.product_name }}
          </h6>
          <span class="drug-generic-name">{{ drug.generic_name }}</span>
        </div>
      </div>
      <div class="with-child-centered" v-else>
        <h5>未搜尋到任何藥物</h5>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'selectDrug',
  data() {
    return {
      query: '',
      query_result: '',
    };
  },
  methods: {
    setDrug(drugId) {
      this.$store.dispatch('setDrug', drugId);
    },
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  mounted() {
    this.$refs.input.focus();
  },
  watch: {
    query() {
      if (this.query.length > 0) {
        this.instance.get('/api/medication/', {
          params: {
            search: this.query,
            type: 'normal',
          },
        })
        .then((res) => {
          this.query_result = res.data.results;
        });
      }

      if (this.query.length === 0) {
        this.query_result = '';
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.drug-search-list--large
  height: 100%;
  padding: 2%;

.drug-button
  flex-direction: column
</style>




// WEBPACK FOOTER //
// DrugSelection.vue?5d174a56